import { render, staticRenderFns } from "./CoursePartOverview.vue?vue&type=template&id=51835dc2&scoped=true"
import script from "./CoursePartOverview.vue?vue&type=script&lang=js"
export * from "./CoursePartOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51835dc2",
  null
  
)

export default component.exports